"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _emotionTheming = require("emotion-theming");

var _classnames = _interopRequireDefault(require("classnames"));

var s = _interopRequireWildcard(require("./styles"));

function TextButton(props) {
  var theme = props.theme,
      children = props.children,
      disabled = props.disabled,
      className = props.className,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["theme", "children", "disabled", "className"]);
  return _react.default.createElement("button", (0, _extends2.default)({
    disabled: disabled,
    className: (0, _classnames.default)(s.root(theme, disabled), className)
  }, otherProps), children);
}

var _default = (0, _emotionTheming.withTheme)(TextButton);

exports.default = _default;